export const EMAIL = 'info@greenlinelog.com';
export const PHONE_NUMBER = { phone: '+13123247724', layer: '+1 (312) 324-7724' };
